import { gql } from '@grandvisionhq/graphql';

const cartDetails = gql`
  fragment CartDetailsFragment on Cart {
    id
    loyaltyDetails {
      cardNumber
      points
    }
  }
`;

export { cartDetails };
//# sourceMappingURL=cart-details.js.map
